import { keyBy } from 'lodash';

export function myCardList(state) {
  return state.myCardList;
}

export function myCards(state) {
  return keyBy(state.myCardList, card => card.id);
}

export function myCardIds(state) {
  return state.myCardList.map(card => (card.id));
}

export function selectedPageList(state) {
  return state.selectedPageList;
}

export function selectedPageIds(state) {
  return state.selectedPageList.map(page => (page.id));
}



// WEBPACK FOOTER //
// ./src/app/my-cards/store/getters.js